import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { showToast } from "./../pages/ToastNotification";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { persistor } from "../redux/store"; // ✅ Import persistor

const initialState = {
    isAuthenticated: false,
    user: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login: (state, action) => {
            const isLocalhost = window.location.hostname === "localhost";
            const { jwtToken, refreshToken, user } = action.payload;
            console.log("isLocalhost :::: ",isLocalhost)

            Cookies.set("jwtToken", jwtToken, {
                expires: 1,
                secure: !isLocalhost, // HTTPS पर true, HTTP पर false
                sameSite: isLocalhost ? "Lax" : "None",
                path: "/"
            });
            
            console.log("JWT Token set in jwtToken:", Cookies.get("jwtToken")); // Debugging

            Cookies.set("refreshToken", refreshToken, {
                expires: 7,
                secure: !isLocalhost,
                sameSite: isLocalhost ? "Lax" : "None",
                path: "/"
            });

            Cookies.set("user", JSON.stringify(user), {
                expires: 1,
                secure: !isLocalhost,
                sameSite: isLocalhost ? "Lax" : "None",
                path: "/"
            });

            console.log("Cookies after login:", {
                jwtToken: Cookies.get("jwtToken"),
                refreshToken: Cookies.get("refreshToken"),
                user: Cookies.get("user"),
            });

            state.isAuthenticated = true;
            state.user = user;
        },
        logout: (state) => {
            Cookies.remove("jwtToken", { path: "/" });
            Cookies.remove("refreshToken", { path: "/" });
            Cookies.remove("user", { path: "/" });

            console.log("Cookies after logout:", {
                jwtToken: Cookies.get("jwtToken"),
                refreshToken: Cookies.get("refreshToken"),
                user: Cookies.get("user"),
            });

            state.isAuthenticated = false;
            state.user = null;
        },
    },
});

export const logoutUser = (navigate) => async (dispatch) => {
    try {
        console.log("Cookies before logout:", {
            jwtToken: Cookies.get("jwtToken"),
            refreshToken: Cookies.get("refreshToken"),
            user: Cookies.get("user"),
        });

        const token = Cookies.get("jwtToken");
        console.log("Token before logout:", token);

        if (!token) {
            throw new Error("No token found");
        }

        // Send logout request to backend
        console.log("Sending logout request to backend..."); // Debugging
        await axiosInstance.post(API_ENDPOINTS.LOGOUT, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });

        // Clear Redux state and cookies
        dispatch(logout());
        Cookies.remove("jwtToken", { path: "/" });
        Cookies.remove("refreshToken", { path: "/" });
        Cookies.remove("user", { path: "/" });

        // Clear persisted state
        await persistor.purge();

        // Redirect to home
        navigate("/");
        showToast("Logout Successful!", "success");
    } catch (error) {
        console.error("Logout Error:", error);
        showToast("Logout failed. Please try again.", "error");
    }
};

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
